export default __webpack_public_path__ + "static/media/support.cb8b7092.svg";